export default "__VITE_ASSET__C4NrHN4e__"